import React, { createContext, useContext, useState, useEffect, useCallback } from 'react';
import { getHotelInfo } from '../services/adminService';
import { useAuth } from './AuthContext';

const HotelFeaturesContext = createContext();

export const useHotelFeatures = () => {
  const ctx = useContext(HotelFeaturesContext);
  if (!ctx) throw new Error('useHotelFeatures must be used within HotelFeaturesProvider');
  return ctx;
};

export const HotelFeaturesProvider = ({ children }) => {
  const { isAuthenticated } = useAuth();
  const [features, setFeatures] = useState({
    isTicketEnabled: false,
    isExploreEnabled: false,
    isHREnabled: false,
  });
  const [featuresLoading, setFeaturesLoading] = useState(true);

  const loadFeatures = useCallback(async () => {
    if (!isAuthenticated) { setFeaturesLoading(false); return; }
    try {
      const info = await getHotelInfo();
      setFeatures({
        isTicketEnabled: info.isTicketEnabled ?? false,
        isExploreEnabled: info.isExploreEnabled ?? false,
        isHREnabled: info.isHREnabled ?? false,
      });
    } catch {
      // keep defaults on error — don't block the UI
    } finally {
      setFeaturesLoading(false);
    }
  }, [isAuthenticated]);

  useEffect(() => { loadFeatures(); }, [loadFeatures]);

  return (
    <HotelFeaturesContext.Provider value={{ ...features, featuresLoading, refreshFeatures: loadFeatures }}>
      {children}
    </HotelFeaturesContext.Provider>
  );
};
